import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { SavingAgreementNotes } from "@app/models/saving-agreement-notes";
import { SavingAgreementNotesService } from "@app/services/saving-agreement-notes.service";

@Component({
    selector: "app-select-saving-agreement-note-popup",
    templateUrl: "./select-saving-agreement-note-popup.component.html",
    styleUrls: ["./select-saving-agreement-note-popup.component.css"],
    standalone: false
})
export class SelectSavingAgreementNotePopupComponent implements OnInit {
  @Input() savingAgreementNotes: Array<SavingAgreementNotes>;
  @Input() displaySearchDialog: boolean;
  @Input() selectedSavingAgreementNotes: Array<SavingAgreementNotes>;
  @Output() onSubmit = new EventEmitter<Array<SavingAgreementNotes>>();
  @Output() onCancel = new EventEmitter();

  constructor(private savingAgreementNotesService: SavingAgreementNotesService) {}

  ngOnInit() {
    if (!this.selectedSavingAgreementNotes) {
      this.selectedSavingAgreementNotes = [];
    }
  }

  hideSearch() {
    this.onCancel.emit();
  }

  onSelect(savingAgreementNote) {
    if (savingAgreementNote) {
      const parentIds = this.savingAgreementNotesService.findSavingAgreementNoteParents(savingAgreementNote, this.savingAgreementNotes);
      this.selectedSavingAgreementNotes = [
        ...this.selectedSavingAgreementNotes.filter((p) => !this.checkIfParentIdInTheList(parentIds, p)),
      ];
      this.selectedSavingAgreementNotes.push(savingAgreementNote);
    }
  }

  onSave() {
    this.onSubmit.emit(this.selectedSavingAgreementNotes);
  }

  deleteSelectedSavingAgreementNote(savingAgreementNote) {
    if (savingAgreementNote) {
      var children = this.findAllChidren(savingAgreementNote);
      this.selectedSavingAgreementNotes = this.selectedSavingAgreementNotes.filter((item) => !children.find((p) => p.id == item.id));

      if (savingAgreementNote.parentSavingAgreementNoteId) {
        var parent = this.savingAgreementNotesService.findSavingAgreementNoteById(savingAgreementNote.parentSavingAgreementNoteId, this.savingAgreementNotes);
        this.selectedSavingAgreementNotes.push(parent);
      }
    }
  }

  checkIfParentIdInTheList(checkArray: SavingAgreementNotes[], savingAgreementNote: SavingAgreementNotes) {
    const set1 = new Set(checkArray);
    const orignalSavingNote = this.savingAgreementNotesService.findSavingAgreementNoteById(savingAgreementNote.id, this.savingAgreementNotes);
    const parents = this.savingAgreementNotesService.findSavingAgreementNoteParents(orignalSavingNote, this.savingAgreementNotes);
    for (const element of parents) {
      if (set1.has(element)) {
        return true;
      }
    }
    return false;
  }

  findAllChidren(savingAgreementNote: SavingAgreementNotes) {
    var items = [];
    if (savingAgreementNote) {
      items.push(savingAgreementNote);
      if (savingAgreementNote.subSavingAgreementNotes && savingAgreementNote.subSavingAgreementNotes.length > 0) {
          savingAgreementNote.subSavingAgreementNotes.forEach((p) => {
          items = items.concat(this.findAllChidren(p));
        });
      }
    }
    return items;
  }
}
